export default __webpack_public_path__ + "static/media/popup_intro.9a92d80c.png";